UsersMainController.$inject = []
function UsersMainController(){
}

export default UsersMainController